import { html, LitElement } from 'lit';
import { customElement, property} from 'lit/decorators.js';
import type { ElementInternals } from "element-internals-polyfill/dist/element-internals";

@customElement('local-time')
export class LocalTime extends LitElement implements HTMLTimeElement {

    @property()
    dateTime: string = '';

    @property()
    format: 'date' | 'datetime' | 'datetime-seconds' | 'datetime-tz' | 'time' | 'time-tz' = 'datetime';

    private internals: ElementInternals;
    private static formatterOptions: { [key in typeof LocalTime.prototype.format]: Intl.DateTimeFormatOptions } = {
        date: {
            dateStyle: 'short'
        },
        datetime: {
            dateStyle: 'short',
            timeStyle: 'short',
        },
        "datetime-seconds": {
            dateStyle: 'short',
            timeStyle: 'medium',
        },
        "datetime-tz": {
            dateStyle: 'short',
            timeStyle: 'long',
        },
        time: {
            timeStyle: 'medium',
        },
        "time-tz": {
            timeStyle: 'long',
        }
    };

    constructor() {
        super();
        this.internals = this.attachInternals();
        this.internals.role = 'time';
    }

    override render() {
        let localizedTime: string;
        try {
            const date = new Date(this.dateTime);
            const format = LocalTime.formatterOptions[this.format];
            if (!format) {
                throw new TypeError(`unknown format value ${this.format}`);
            }
            localizedTime = Intl.DateTimeFormat(undefined, format).format(date);
        } catch (e) {
            localizedTime = '!!!ERR!!!';
            console.error(e);
        }
        return html`
            <span>${localizedTime}</span>
        `;
    }
}
